module.exports = __webpack_public_path__ + "img/hanging-email.db194b55.svg";